<template>
  <div class="exchange-i">
    <Header title="调课申请" type="0" route="/homeIndex"></Header>
    <NOdata
      v-if="this.exchangeList && this.exchangeList.length == 0"
      title="未查询到任何信息"
    ></NOdata>
    <div class="exchange">
      <div
        class="item"
        v-for="(item, index) of exchangeList"
        :key="index"
        @click="goItem(item)"
      >
        <p>{{ item.courseName }}</p>
        <ul>
          <li>班级：{{ item.className }}</li>
          <li>周次：{{ item.week }}</li>
          <li>时间：{{ item.weekNote }}</li>
        </ul>
      </div>
    </div>
    <div class="bottom-btn">
      <button @click="goItem('')">申请记录</button>
    </div>


    <van-dialog
        v-model="textShow"
        class="my-Dialog"
        title="调课提示"
      >
      <div   class="popup-content" v-html="tkxlsm"></div>
      <div class="searchbtn_ts" style="background-color: #f2f2f4;">
        <button style="background-color: #7469f8;color: #fff;font-size: 10px;width: 150px;height: 30px;border-radius: 10px;"  @click="tsToTksq()">已阅并关闭</button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Api } from "../../../../utils/axios";
export default {
  data() {
    return {
      exchangeList: [],
      schoolCode: '',
      textShow:false,
      tkxlsm:'',
      router_item:{}
    };
  },
  methods: {
    // 获取课程列表
    async getList() {
      const res = await Api.teachGetJsskxx();
      this.exchangeList = res.data;
    },
    async goItem(item) {
      console.log(this.schoolCode, 'this.schoolCode');
      if(this.schoolCode == '12711') {
        this.$router.push({
          path: "/teacher/changeCoures",
          query: {
            i_item: item,
            tabActive: item === '' ? 'rightIcon' : ''
          }
        })
        return
      }
      if(this.schoolCode == '11114') {
        this.router_item = {}
        let param = {
          xnxq01id: item.semesterId
        };
        const res = await Api.showTips(param);
        const tipscontent = res.tipscontent
        if(tipscontent != null && tipscontent != ''){
          this.tkxlsm = tipscontent
          this.textShow = true
          this.router_item = item
        }else{
            this.$router.push({
            path: "/exchangeK/item",
            query: {
              i_item: item
            }
          });
        }
      }else{
        this.$router.push({
          path: "/exchangeK/item",
          query: {
            i_item: item
          }
        });
      }
    },
    tsToTksq(){
      this.textShow = false
      this.$router.push({
        path: "/exchangeK/item",
        query: {
          i_item: this.router_item
        }
      });
    }
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.exchange-i {
  .exchange {
    padding: 5% 5% 0;
    overflow: auto;
    height: 80vh;
    .item {
      background: #f8f8f8;
      border-radius: 5px;
      margin: 0 auto 5%;
      padding: 3% 0 3% 6%;
      box-sizing: border-box;

      p {
        height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        font-weight: bolder;
        margin-bottom: 2%;
      }
      ul {
        li {
          height: 16px;
          font-family: PingFangSC-Light;
          font-size: 12px;
          color: #757da3;
          letter-spacing: 0;
          line-height: 16px;
          margin-bottom: 1%;
        }
      }
    }
  }
  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    padding: 0 5%;
    background: #fff;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
.my-Dialog {
    width: 90%;
    height: 410px;
    .popup-content {
        font-family: PingFangSC-Regular;
        height: 300px;
        margin-top: 10px;
        font-size: 14px;
        color: #999999;
        width: 90%;
        border: 1px solid #dadae0;
        white-space: pre-line;
        padding-top: 5px ;
        overflow:auto
      }
    p {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #7d7e80;
      text-align: center;
      line-height: 20px;
      padding: 10px 0;
    }
    p {
      color: red;
    }
  }
  .van-dialog__header{
    padding-top: 10px;
  }
  .van-dialog__content div{
    padding-left: 10px;
    padding-right: 10px;
    margin: auto;
    background-color: #fff;
  }
  .searchbtn_ts{
    height: 30px;
    padding-top:6px;
    line-height: 30px;
    margin: auto;
    text-align: center;
    background-color: #f2f2f4;
    
  }
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/exchangeK/index.vue